import { useFetch } from './useFetch'
import type { VenueDTO } from '../types'

export function useVenues() {
  const { data: venues, isLoading, error } =
    useFetch<VenueDTO[]>('/v1/venues', [])
  return { venues, isLoading, error }
}
